var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAboutLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3733_1184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.6154 0H39.3846C17.6331 0 0 17.6331 0 39.3846V88.6154C0 110.367 17.6331 128 39.3846 128H88.6154C110.367 128 128 110.367 128 88.6154V39.3846C128 17.6331 110.367 0 88.6154 0Z",
    fill: "url(#paint0_linear_3733_1184)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3076 67.457L28.311 67.5579C28.3122 67.5879 28.3163 67.6913 28.3184 67.7356C28.3228 67.8238 28.3291 67.9409 28.3384 68.0847C28.357 68.3722 28.3873 68.7685 28.4362 69.2574C28.5338 70.2331 28.7066 71.5904 29.0112 73.2047C29.6149 76.4037 30.7647 80.7636 32.9796 85.2007C35.1976 89.6438 38.5801 94.3532 43.7347 97.9564C48.9641 101.612 55.6632 103.877 63.9999 103.877C72.3367 103.877 79.036 101.612 84.2653 97.9564C89.4197 94.3532 92.8024 89.6438 95.0202 85.2007C97.2351 80.7636 98.3852 76.4037 98.9887 73.2047C99.2935 71.5904 99.4663 70.2331 99.5637 69.2574C99.6125 68.7685 99.643 68.3722 99.6612 68.0847C99.6706 67.9409 99.677 67.8238 99.6814 67.7356C99.6834 67.6913 99.6853 67.6544 99.6863 67.6244L99.6922 67.457V32H28.3076V67.457ZM86.6992 67.2128V44.5243H41.3008V67.2128C41.3023 67.2384 41.3041 67.2699 41.3065 67.3068C41.3166 67.4629 41.3356 67.7169 41.3694 68.0551C41.4373 68.734 41.5639 69.7408 41.7946 70.9632C42.2616 73.438 43.1266 76.6425 44.6879 79.7701C46.246 82.8918 48.401 85.7472 51.3629 87.8174C54.2498 89.8353 58.2453 91.3526 63.9999 91.3526C69.7545 91.3526 73.7501 89.8353 76.637 87.8174C79.5987 85.7472 81.754 82.8918 83.3122 79.7701C84.8733 76.6425 85.7383 73.438 86.2055 70.9632C86.4359 69.7408 86.5624 68.734 86.6303 68.0551C86.6643 67.7169 86.6835 67.4629 86.6933 67.3073C86.6958 67.2699 86.6978 67.2384 86.6992 67.2128Z",
    fill: "url(#paint1_linear_3733_1184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0004 55.0769C67.5883 55.0769 70.4969 57.8806 70.4969 61.3391V61.8653C70.4969 63.7622 69.6221 65.4621 68.2397 66.6102L70.4969 76.4056H57.5039L60.0388 66.8288C58.4969 65.6837 57.5039 63.8863 57.5039 61.8653V61.3391C57.5039 57.8806 60.4125 55.0769 64.0004 55.0769Z",
    fill: "url(#paint2_linear_3733_1184)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3733_1184",
    x1: -2962.04,
    y1: 13965.3,
    x2: 11191.6,
    y2: 3827.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3362FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3733_1184",
    x1: 1442.01,
    y1: 1842.22,
    x2: -1414.08,
    y2: -1121.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3733_1184",
    x1: 1518.13,
    y1: 2560.73,
    x2: 3522.62,
    y2: 4641.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3733_1184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAboutLogo);
export default __webpack_public_path__ + "static/media/icon-about-logo.e58e91deeab4d57b979c1bc0cd415a0f.svg";
export { ForwardRef as ReactComponent };